function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import ModelListener from './utils/ModelListener';
/**
 * Update callback function
 * @callback ModelComponent~updateCallback
 * @param {Model} model Model
 * @param {Component} component Component
 * @param {?object} changed Model's change event parameters. Null if the callback is triggered by render or setModel.
 */

/**
 * A generic component wrapper that listens to change events on a model, calling update on change.
 */

var ModelComponent =
/*#__PURE__*/
function () {
  /**
   * Creates a new ModelComponent instance
   * @param {Model} [model] Optional model object
   * @param {Component} component Component
   * @param {ModelComponent~updateCallback} update Callback function called on model change and when component is rendered
   */
  function ModelComponent(model, component, update) {
    _classCallCheck(this, ModelComponent);

    if (typeof component === 'function') {
      update = component;
      component = model;
      model = null;
    }

    this.ml = new ModelListener(model, component, update);
  }
  /**
   * Set model
   * If component is rendered, update will be triggered.
   * @param {?Model} model Model
   * @returns {this}
   */


  _createClass(ModelComponent, [{
    key: "setModel",
    value: function setModel(model) {
      this.ml.setModel(model);
      return this;
    }
  }, {
    key: "render",
    value: function render(el) {
      this.ml.onRender();
      return this.ml.component.render(el);
    }
  }, {
    key: "unrender",
    value: function unrender() {
      this.ml.component.unrender();
      this.ml.onUnrender();
    }
  }]);

  return ModelComponent;
}();

export default ModelComponent;